import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { ControlContainer, NgForm } from '@angular/forms';
import * as _ from 'lodash';
import { WorkflowComponent } from '../../workflow.component';

@Component({
    selector: 'subscriber-fiscal-information',
    templateUrl: './subscriber-fiscal-information.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class SubscriberFiscalInformationComponent implements OnInit, OnDestroy, ICardComponent {
  public cardData: models.SubscriberFiscalInformationVM = {} as models.SubscriberFiscalInformationVM;
  public cardConfiguration: models.CardVM;
  public parentWorkflow: WorkflowComponent;
  public isWorkflowOnSubscriber: boolean = false;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.fiscalCategories)
  public fiscalCategories : models.DimensionVM[];
  @CommonData(DomainCodes.incomeHolding)
  public incomeHoldings: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
 


  constructor(private http: HttpClient, private activeRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  isVersion2() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  getOrderedIncomeHoldings() {
    return _.sortBy(this.incomeHoldings, x => x.value);
  }

  isWorkflowCompulsoryAndOnService(): boolean {
    let isService = !this.isWorkflowOnSubscriber;
    let isCompulsory = !this.isVoluntary();

    return isService && isCompulsory;
  }

  isVoluntary(): boolean {
    let result = false;
    let voluntaryFundaments = ['PEDI001A', 'PEDI001B', 'PEDI001C', 'PEDI001D', 'PEDI001L', 'PEDI001F', 'PEDI001H', 'PEDI001I', 'PEDI001K', 'PEDI001O', 'PEDI001P', 'PEDI001S', 'PEDI001T', 'PEDI001V', 'PEDI001X', 'PEDI001Y', 'PEDI001Z', 'PEDI001AB', 'PEDI001AC', 'PEDI001AD'];
    if (voluntaryFundaments.indexOf(this.parentWorkflow['workflowInstance']['workflowCode']) >= 0) {
      result = true;
    }

    return result;
  }
}
